import React, { useState } from 'react';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWindowRestore, faAngleDown } from '@fortawesome/pro-regular-svg-icons';
import { faArrowsAltH } from '@fortawesome/pro-solid-svg-icons';
import { designBaseUrl, Content, BasicOption } from '../../lib/FL';
import TextLink from './TextLink';
import CardLink from './CardLink';
import styles from './SetCard.module.scss';

type Props = {
  basicContents?: Content[];
  option: BasicOption;
};

const SetCard: React.FC<Props> = ({ basicContents, option }) => {
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const toggleAccordion = () => setIsOpen(!isOpen);
  const getContentImageUrl: (content: Content) => string = (content) =>
    `${designBaseUrl}/assets_resized/formatline/design/pc/contents/${content.en_name}/catalog.png`;

  return (
    <section className={styles.set} key={option.id}>
      <button
        className={styles.set__title}
        aria-expanded={isOpen}
        aria-controls={`option_${option.id}`}
        type='button'
        onClick={toggleAccordion}
      >
        {option.for}向けセット
        <span className={styles.set__title__icon}>
          <FontAwesomeIcon icon={faAngleDown} />
        </span>
      </button>
      <div className={styles.set__container} id={`option_${option.id}`} aria-hidden={!isOpen}>
        <div className={styles.options}>
          <div className={styles.options__default}>
            <h2 className={styles.options__default__title}>基本5点セット</h2>
            <ul className={styles.options__default__list}>
              {basicContents?.map((content) => (
                <li className={styles.options__default__item} key={content.en_name}>
                  <TextLink content={content} business={option.sample_page_name}>
                    <FontAwesomeIcon className={styles.options__default__icon} icon={faWindowRestore} />
                    {content.ja_name}
                  </TextLink>
                </li>
              ))}
            </ul>
          </div>
          <div className={styles.options__icon}>
            <FontAwesomeIcon className={styles.options__icon__svg} icon={faPlus} />
          </div>
          <div className={styles.options__add}>
            <h2 className={styles.options__add__title}>追加コンテンツ</h2>
            <ul className={styles.options__add__list}>
              {option.contents.map((content) => (
                <li className={styles.options__add__item} key={content.en_name}>
                  <CardLink content={content}>
                    <img className={styles.options__add__pic} src={getContentImageUrl(content)} alt={content.ja_name} />
                    <span className={styles.options__add__notes}>
                      <FontAwesomeIcon className={styles.options__add__notes__icon} icon={faWindowRestore} />
                      {content.ja_name}
                    </span>
                  </CardLink>
                </li>
              ))}
              <div className={styles.options__add__select}>
                <FontAwesomeIcon className={styles.options__add__select__icon} icon={faArrowsAltH} />
                どちらか
                <br className={styles.options__add__select__br} />
                選択
              </div>
            </ul>
          </div>
        </div>
        <div className={styles.expenses}>
          <div className={styles.expenses__title}>PC・スマホ同時対応</div>
          <div className={styles.expenses__main}>
            <span className={styles.expenses__main__title}>制作費</span>
            <span className={styles.expenses__main__price}>{option.price.toLocaleString()}</span>
            <span className={styles.expenses__main__unit}>円</span>
          </div>
        </div>
        <div className={styles.notes}>
          ※制作費（制作料金）の他、別途月額費用が発生します。
          <br />
          ホームページ保守管理費用（テキスト修正のみ対応）…20,000円/月
          {option.contents.some((content) => content.en_name === 'list') &&
            '／『ラルズマネージャー』の利用…10,000円/月'}
        </div>
      </div>
    </section>
  );
};

SetCard.defaultProps = {
  basicContents: undefined,
};

export default SetCard;
